import { render, staticRenderFns } from "./chengshi.vue?vue&type=template&id=65e62ca0&scoped=true&"
import script from "./chengshi.vue?vue&type=script&lang=js&"
export * from "./chengshi.vue?vue&type=script&lang=js&"
import style0 from "./chengshi.vue?vue&type=style&index=0&id=65e62ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e62ca0",
  null
  
)

export default component.exports